export const WEBCHAT_SOURCE = 'chatbot_site';

export const WEBCHAT_CUSTOMER_IDENTIFIER_PREFIX = 'cliente-';

export const WEBCHAT_VISITOR_IDENTIFIER_PREFIX = 'visitante-';

/**
 * origemLead do lead criado pelo pré-chat. O Vectis cria a configuração de
 * origem CHATBOT_SITE sozinho no primeiro cadastro, sem deploy de backend.
 */
export const WEBCHAT_LEAD_ORIGIN = {
  key: 'CHATBOT_SITE',
  channel: 'SITE',
};

/**
 * Manda o lead do pré-chat para a Central de Vendas (unidade 25 do Vectis) em
 * vez da unidade do e-commerce, que fica só como tag. Troque aqui se o
 * atendimento do chat mudar de dono.
 */
export const WEBCHAT_LEAD_SENT_TO_SALES_CENTER = true;

/**
 * O PUT /clientes recusa celular repetido com HTTP 400 e a mensagem já
 * traduzida pelo Vectis (label.cliente.validacao.foneCelular.duplicado), sem
 * código de erro próprio. Por isso a comparação é pelo texto, em pt_BR e es_PY.
 */
export const WEBCHAT_DUPLICATED_PHONE_MESSAGES = [
  'label.cliente.validacao.foneCelular.duplicado',
  'Este número de celular já está cadastrado para outro cliente',
  'Este número de móvil ya está registrado para otro cliente',
];
